import React, { useContext, useState } from "react";
import styles from "./styles/AddBeneficiary.module.css";
import { UserData } from "../../../Context/DataContext";
import { useEffect, useRef } from "react";
import NewTrustee from "../Add Trustee/NewTrustee";
import NewBeneficiary from "../Add Beneficiary/new_beneficiary";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
function AddBeneficiary({
  setShow,
  alreadySelected,
  user_type,
  onSelect,
  specialStyle = false,
}) {
  const [options, showOptions] = useState();
  const userData = UserData();
  const wrapperRef = useRef(null);
  const [openAdd, setOpenAdd] = useState(false);
  const handleOpenAdd = () => {
    setOpenAdd(true);
    setShow(false);
  };
  const optionsStyles = {};
  if (user_type === "trustees") {
    optionsStyles.left = 0;
  }
  if (
    (user_type === "beneficiaries" || user_type === "trustees") &&
    specialStyle
  ) {
    optionsStyles.width = "220px";
  }

  const handleCloseAdd = () => {
    setOpenAdd(false);
    setShow(true);
  };
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddAsset.AddBeneficiary
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddAsset.AddBeneficiary);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        event.target.innerText !== "OK"
      ) {
        showOptions(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const beneficiariesAmount = UserData().UserData.beneficiaries.length;
  const selectedItems = userData.UserData[user_type].filter(
    (user) => !alreadySelected.includes(user.user_id)
  );
  selectedItems.sort((a, b) => {
    if (a.priority === b.priority) {
      return a.name.localeCompare(b.name);
    }
    return a.priority - b.priority;
  });
  return (
    <div
      onClick={() => showOptions(!options)}
      ref={wrapperRef}
      className={styles.main}
      style={
        specialStyle && user_type === "trustees"
          ? {
              position: "static",
            }
          : {}
      }
    >
      <div className={styles.add_asset}></div>
      {options ? (
        <>
          <div
            onClick={(e) => e.stopPropagation()}
            className={styles.options}
            style={{ ...optionsStyles }}
          >
            <div
              style={{ width: "100%", height: "20px", position: "relative" }}
            >
              <div
                onClick={() => showOptions(false)}
                className={styles.close}
              />
            </div>
            {selectedItems.map((individual) => {
              let initials = "";
              individual.name
                .split(" ")
                .map((n) => (initials = initials + n[0]));
              let extension;

              individual.profile_avatar &&
                (extension = individual.profile_avatar[0]);
              if (extension === "/") extension = ".jpg";
              else if (extension === "i") extension = ".png";

              return (
                <div
                  key={individual.user_id}
                  onClick={() => onSelect(individual)}
                  className={styles.option_cell}
                >
                  {/* {individual.profile_avatar ? (
                      <img
                        src={`data:image/${extension};base64,${individual.profile_avatar}`}
                        alt="profle"
                      />
                    ) : (
                      <span> {individual?.name[0]}</span>
                    )} */}

                  {individual.profile_avatar ? (
                    <img
                      style={{
                        paddingTop: "unset",
                      }}
                      className={styles.beneficiary_trustee}
                      alt="avatar"
                      src={`data:image/${extension};base64,${individual.profile_avatar}`}
                    ></img>
                  ) : (
                    <div
                      className={`${styles.beneficiary_trustee} ${
                        individual.priority === "1"
                          ? styles.priority1
                          : individual.priority === "2"
                          ? styles.priority2
                          : ""
                      }`}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textWrap: "nowrap",
                        }}
                      >
                        {/* {initials} */}{" "}
                        {initials.length > 4 ? (
                          <>{initials.slice(0, 4)}...</>
                        ) : (
                          initials
                        )}
                      </span>
                    </div>
                  )}
                  <span
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      width: "70%",
                      maxHeight: "2.5em",
                      lineClamp: 2,
                      WebkitLineClamp: 2,
                      wordBreak: "break-all",
                      WebkitBoxOrient: "vertical",
                      display: "-webkit-box",
                      wordBreak: "break-all",

                      // wordBreak: "break-all",
                    }}
                  >
                    {/* {individual.name +
                      ("last_name" in individual
                        ? " " + individual.last_name
                        : ""
                      ).slice(0, 15)} */}
                    {/* {individual.name.length >= 42
                      ? individual.name.slice(0, 42) + "..."
                      : individual.name} */}

                    {individual.name}
                  </span>
                </div>
              );
            })}

            {user_type === "trustees" && (
              <div
                className={`${styles.option_cell} ${styles.option_cell_add}`}
                onClick={() => {
                  handleOpenAdd();
                }}
              >
                <div className={styles.add_asset_small}></div>
                {dublicatedcontent.dublicatedText73}
              </div>
            )}

            {user_type === "beneficiaries" && beneficiariesAmount < 12 && (
              <div
                className={`${styles.option_cell} ${styles.option_cell_add}`}
                onClick={() => {
                  handleOpenAdd();
                }}
              >
                <div className={styles.add_asset_small}></div>
                {content.addBeneficiaryText2}
              </div>
            )}

            {openAdd ? (
              user_type === "beneficiaries" ? (
                <NewBeneficiary onClose={() => handleCloseAdd()} />
              ) : (
                <NewTrustee onClose={() => handleCloseAdd()} />
              )
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default AddBeneficiary;
